export const LESSON_DETAIL_SHARED_FILE = 'LessonDetailSharedFile';
export const LESSON_DETAIL_COMMENTED = 'LessonDetailCommented';
export const LESSON_DETAIL_REPLY = 'LessonDetailReply';
export const LESSON_DETAIL_ADMIN_DELETE_COMMENT = 'LessonDetailAdminDeleteComment';
export const LESSON_DETAIL_ADMIN_DELETE_FILE = 'LessonDetailAdminDeleteFile';
